/* Pouches LP flavour showcase.
   The cans form a ring: each has a position (--pos / data-pos) relative to the active one, 0 = centre,
   -1/+1 either side and so on. With fewer than five flavours the liquid renders every can twice, so the
   desktop row (five slots) can show the loop on both edges; a clone is just another stop on the ring.
   Auto-advances only while the section is on screen; swipe (mobile) and arrows (desktop) move it by
   hand and restart the timer. */
(function () {
  'use strict';

  function init(root) {
    if (root.__pk) return;
    root.__pk = 1;
    var items = [].slice.call(root.querySelectorAll('[data-pk-item]'));
    var names = [].slice.call(root.querySelectorAll('.pk__names [data-pk-info]'));
    var rows = [].slice.call(root.querySelectorAll('.pk__stats [data-pk-info]'));
    var bars = [].slice.call(root.querySelectorAll('[data-pk-bar]'));
    var n = names.length, ring = items.length;
    if (!n) return;
    var dur = (parseFloat(root.getAttribute('data-pk-dur')) || 4.5) * 1000;
    root.style.setProperty('--pk-dur', dur / 1000 + 's');
    var cur = 0, timer = null, visible = false;

    /* position of ring node j relative to the active node, wrapped into -floor(ring/2) .. ceil(ring/2)-1 */
    function posOf(j) {
      var p = ((j - cur) % ring + ring) % ring;
      if (p > Math.floor((ring - 1) / 2)) p -= ring;
      return p;
    }

    function render() {
      var f = cur % n;
      items.forEach(function (it, j) {
        var p = posOf(j);
        var old = parseInt(it.getAttribute('data-pos'), 10);
        var jump = !isNaN(old) && Math.abs(p - old) > 2;
        if (jump) it.classList.add('is-jump');
        it.setAttribute('data-pos', p);
        it.style.setProperty('--pos', p);
        it.classList.toggle('is-active', p === 0);
        if (jump) { void it.offsetWidth; setTimeout(function () { it.classList.remove('is-jump'); }, 30); }
      });
      names.forEach(function (el, i) { el.classList.toggle('is-active', i === f); });
      rows.forEach(function (el, i) { el.classList.toggle('is-active', i === f); });
      bars.forEach(function (b, i) {
        b.classList.toggle('is-done', i < f);
        b.classList.remove('is-run');
      });
      if (bars[f]) { void bars[f].offsetWidth; bars[f].classList.add('is-run'); }
    }

    function schedule() {
      clearTimeout(timer);
      timer = null;
      root.classList.toggle('is-paused', !visible);
      if (visible && n > 1) timer = setTimeout(function () { step(1); }, dur);
    }
    /* step by one stop round the ring */
    function step(d) { go(cur + d); }
    function go(i) {
      cur = ((i % ring) + ring) % ring;
      render();
      schedule();
    }
    /* jump to flavour f by the shortest way round from where we are */
    function show(f) {
      if (cur % n === f) return;
      var best = cur, bd = Infinity;
      for (var j = f; j < ring; j += n) {
        var d = Math.abs(posOf(j));
        if (d < bd) { bd = d; best = j; }
      }
      go(best);
    }

    var prev = root.querySelector('[data-pk-prev]'), next = root.querySelector('[data-pk-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    /* swipe on the stage */
    var stage = root.querySelector('[data-pk-stage]'), sx = null, sy = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        sx = sy = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    /* run only while at least a third of the section is on screen; restart the current flavour on return */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var was = visible;
          visible = e.isIntersecting;
          if (visible && !was) go(cur); else if (!visible) schedule();
        });
      }, { threshold: 0.33 }).observe(root);
    } else {
      visible = true;
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearTimeout(timer); root.classList.add('is-paused'); }
      else if (visible) go(cur);
    });

    root.__pkApi = { go: go, show: show, step: step, get: function () { return cur % n; },
      setVisible: function (v) { visible = v; if (v) go(cur); else schedule(); } };
    render();
    schedule();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-pk]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
